//@author travis

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import { DropDownItem } from "../../../pojo/DropDownItem";
import { S25ItemI } from "../../../pojo/S25ItemI";
import { S25Util } from "../../../util/s25-util";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-ng-contacts-editable")
@Component({
    selector: "s25-ng-contacts-editable",
    template: ` @if (this.init) {
        <div>
            @for (contact of modelBean; track contact; let i = $index) {
                <div class="c-margin-bottom--quarter">
                    <div class="row-flex">
                        <s25-ng-icon [type]="'close'" [label]="'Delete'" (click)="remove(contact)"></s25-ng-icon>
                        <span class="c-margin-right--single"></span>
                        <s25-item-contact
                            [modelBean]="{
                                itemId: +contact.itemId,
                                itemName: contact.itemName,
                            }"
                            [includeTypeIcon]="true"
                        ></s25-item-contact>
                    </div>
                    <span class="ng-binding notification-policy--dropdown">
                        <!--<s25-generic-dropdown [items]="this.dropDownItems" [(chosen)]="contact.property" [searchEnabled]="false" (chosenChange)="setType($event, i)"></s25-generic-dropdown>-->
                        <s25-ng-dropdown-search-criteria
                            [type]="'organizationRoles'"
                            [(chosen)]="contact.property"
                            (chosenChange)="setType($event, i)"
                        ></s25-ng-dropdown-search-criteria>
                    </span>
                    @if (primaryContact) {
                        <span class="ngCpointer ng-scope c-margin-right--half primary-contact--radio">
                            <label for="primaryContact_{{ contact.itemId }}">
                                <input
                                    type="radio"
                                    id="primaryContact_{{ contact.itemId }}"
                                    name="primary"
                                    (click)="setPrimary(contact)"
                                    (keydown.enter)="setPrimary(contact)"
                                />Primary Contact
                            </label>
                        </span>
                    }
                </div>
            }
            <div class="c-margin-top--single">
                <span class="ngBold">Add Contact</span>
                <s25-contact-dropdown
                    (chosenChange)="addContact($event)"
                    [r25UserOnly]="this.r25UserOnly"
                    [resetSelectedOnCleanup]="true"
                ></s25-contact-dropdown>
            </div>
        </div>
    }`,
    styles: [
        `
            .row-flex {
                display: flex;
                align-items: center;
            }

            :host ::ng-deep .s25-item-holder {
                display: flex;
                align-items: center;
                cursor: pointer !important;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})

/**
 * Component for picking a number of contacts with an additional property.
 */
export class S25ContactsEditableComponent implements OnInit {
    @Input() itemTypeId: number = 3;
    @Input() modelBean: S25ItemI[] = []; //S25ItemI + property: {itemId: itemName: }
    @Input() dropDownItems?: DropDownItem[]; //items to display in the dropdown OR some sort of code for a generic dropdown?
    @Input() dropDownLabel?: string;
    @Input() r25UserOnly?: boolean = true;
    @Input() primaryContact: boolean; //Show or hide primary contact chooser
    @Output() modelBeanChange = new EventEmitter<S25ItemI[]>();
    newContact: DropDownItem = null;
    init: boolean = false;

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        this.elementRef.nativeElement.angBridge = this;
    }

    ngOnInit(): void {
        this.modelBean = S25Util.array.forceArray(this.modelBean);
        this.init = true;
        this.cd.detectChanges();
    }

    addContact(event: any) {
        !S25Util.array.isIn(this.modelBean, "itemId", event.itemId) && this.modelBean.push(event);
        this.modelBeanChange.emit(this.modelBean);
    }

    remove(item: any) {
        S25Util.array.inplaceRemoveByProp(this.modelBean, "itemId", item.itemId);
        this.cd.detectChanges();
        this.modelBeanChange.emit(this.modelBean);
    }

    setPrimary(item: any) {
        let i = S25Util.array.findByProp(this.modelBean, "isPrimary", true);
        if (i > -1) {
            this.modelBean[i].isPrimary = false;
        }
        item.isPrimary = true;
        this.modelBeanChange.emit(this.modelBean);
    }

    setType(event: any, i: number) {}
}
